<div nz-row>
  <div nz-col nzSpan="6">
    <span class="pageTitle">My Query Request</span>
  </div>
  <div nz-col nzSpan="8">
    <div class="search-container">
      <nz-input-group [nzPrefix]="searchIcon">
        <input nz-input type="text" placeholder="Enter minimum 3 characters to search..." [(ngModel)]="searchText"
          (input)="searchQuery()" class="search-box" />
      </nz-input-group>
      <ng-template #searchIcon>
        <i nz-icon nzType="search"></i>
      </ng-template>
    </div>
  </div>
  <div nz-col nzSpan="10" *ngIf="currentUser.Is_Partner">
    <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
      <button nz-button nzType="primary" style="margin-right: 10px;" (click)="GoToCreateQuery()">Submit New
        Query</button>
      <button nz-button *ngIf="filteredQueryRequest.length > 0" nzType="primary" (click)="exportToExcel()">
        <i nz-icon nzType="file-excel" nzTheme="outline"  style="color: white;"></i> Export to Excel
      </button>

    </div>
  </div>
</div>

<nz-table *ngIf="currentUser.Is_Partner" #partnerTable [nzScroll]="{ x: '1900px' }" [nzData]="filteredQueryRequest"
  [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true">
  <thead>
    <tr>
      <th *ngFor="let column of partnerTableColumns" [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
        [nzShowSort]="column.showShort" style="padding: 5px; font-size: 12px; font-weight: 100;">
        {{ column.title }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let query of partnerTable.data">
      <td style="width: 120px;">
        <div *ngIf="query.RequestorCode == currentUser.User_Code">
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode != queryResponseEnum
                        && query.QueryStatusCode != queryDeleteByAdminEnum
                        && query.QueryStatusCode != queryDeleteByPartnerEnum)" (click)="showDeleteConfirm(query)"
            value="Delete" style="margin-right: 2px;">Delete</button>
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="query.QueryStatusCode == queryResponseEnum"
            routerLink="/clarification-query/reopen-query/{{query.QueryCode}}" value="Re-Open">Re-Open</button>&nbsp;
        </div>
      </td>
      <td style="font-size: 80%;">

        <a [routerLink]="['/clarification-query/view-query', query.QueryCode]">
          <strong>{{query.QueryRequestNumber}}</strong>
        </a>

      </td>
      <td>{{query.Subject}}</td>
      <td>{{query.PartnerQueryStatus}}</td>
      <td>{{query.RequestorName}}</td>
      <td>{{query.CompanyName}}</td>
      <td>{{query.Block}}</td>
      <td>{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
      <td>{{query.PriorityLevel}}</td>
      <td>{{query.Confidential}}</td>
      <td>{{query.Department}}</td>
      <td>{{query.SubDeptartment}}</td>
      <td>{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
      <td>{{query.CreatedByUserName}}</td>
    </tr>
  </tbody>
</nz-table>



<nz-table *ngIf="!currentUser.Is_Partner" #nonPartnerTable [nzScroll]="{ x: '1900px' }" [nzData]="filteredQueryRequest"
  [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true">
  <thead>
    <tr>
      <th *ngFor="let column of nonPartnerTableColumns" [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
        [nzShowSort]="column.showShort" style="padding: 5px; font-size: 12px; font-weight: 100;">
        {{ column.title }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let query of nonPartnerTable.data">
      <td class="text-center"><a routerLink="/clarification-query/view-query/{{query.QueryCode}}">
          <strong>{{query.QueryRequestNumber}}</strong></a>
      </td>
      <td class="text-center">{{query.Subject}}</td>
      <td class="text-center"><strong>{{query.QueryStatus}}</strong>
        <div *ngIf="(query.QueryStatusCode == queryAssgnToDepRepEnum || query.QueryStatusCode == queryRecycledEnum)">
          <small *ngFor="let name of query.QueryAssignedTo?.split('|')">
          {{ name }}</small>
      </div>
        <div *ngIf="(query.QueryStatusCode == queryAnsweredByDeptEnum || query.QueryStatusCode == queryAnsweredBySponsorEnum)">
          <small *ngFor="let name of query.QueryAnsBy?.split('|')">
          {{ name }}</small>
    </div>
      </td>
      <td class="text-center">{{query.RequestorName}}</td>
      <td class="text-center">{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
      <td class="text-center">{{query.Category}}</td>
      <td class="text-center">{{query.SubCategory}}</td>
      <td class="text-center">{{query.Block}}</td>
      <td class="text-center">{{query.PriorityLevel}}</td>
      <td class="text-center">{{query.Confidential}}</td>
      <td class="text-center">{{query.Department}}</td>
      <td class="text-center">{{query.SubDeptartment}}</td>
      <td class="text-center">{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
      <td class="text-center">{{query.CreatedByUserName}}</td>
      <td class="text-center">{{query.QueryReqDueDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
    </tr>
  </tbody>
</nz-table>

